/* Diamond Studio — center stone carat filter helpers (2026-09-30), collection pages. The carat row itself is rendered by
   snippets/ds-collection-facets.liquid from the storefront filter on custom.main_diamond_carat_weight.
   1. Chips: the collection section also lists this filter's raw values ("5", "5.00", "5.00 CT"...) and makes a chip for
      each chosen one. Those chips remove fewer carat values than the page has, so they are dropped; the chosen size
      keeps its own "5 ct" chip, and the filter count is corrected.
   2. Measurement: clicks on the carat row go to dataLayer as "ds_carat_filter" (carat, placement strip/panel).
   3. Phones: the shape and carat rows scroll sideways and start at the left after every page update, which can hide
      the chosen size or shape (5 ct or Princess, for example). Each row is scrolled sideways to show its choice.
      Only the row's own sideways position changes, so nothing on the page moves.
   Loaded with defer, after the section has drawn its first chips, so it runs once at start and after every update. */
(() => {
  'use strict';
  if (window.DSCaratFilter) return;
  window.DSCaratFilter = {version: '2026-09-30'};
  const PARAM = 'filter.p.m.custom.main_diamond_carat_weight';

  function clean() {
    const root = document.querySelector('[data-ds-collection]');
    const box = root?.querySelector('[data-dsc-active-filters]');
    if (!box) return;
    const chosen = new URL(location.href).searchParams.getAll(PARAM).length;
    if (!chosen) return;
    let removed = 0;
    box.querySelectorAll('a[data-dsc-native-filter]').forEach(chip => {
      try {
        if (new URL(chip.href, location.href).searchParams.getAll(PARAM).length < chosen) {
          chip.remove();
          removed++;
        }
      } catch (e) { /* leave the chip */ }
    });
    const count = root.querySelector('[data-dsc-filter-count]');
    if (removed && count) count.textContent = box.children.length ? '(' + box.children.length + ')' : '';
  }

  function reveal() {
    const rows = '.dsc-shape-strip .dsc-facet-group--strip, .dsc-shape-strip .dsc-facet-group--strip > .dsc-facet-grid';
    document.querySelectorAll(rows).forEach(row => {
      if (row.scrollWidth <= row.clientWidth + 1) return;
      const chosen = row.querySelector('.dsc-facet[aria-current]:not([data-dsc-all])');
      if (!chosen) return;
      const rowBox = row.getBoundingClientRect();
      const box = chosen.getBoundingClientRect();
      if (box.left >= rowBox.left && box.right <= rowBox.right) return;
      row.scrollLeft += box.left - rowBox.left - (rowBox.width - box.width) / 2;
    });
  }
  function update() {
    clean();
    reveal();
  }

  document.addEventListener('ds:collection:updated', update);
  window.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[data-dsc-facet="carat"]') : null;
    if (!link) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ds_carat_filter',
      carat: link.dataset.dscValue || 'all',
      placement: link.closest('.dsc-shape-strip') ? 'strip' : 'panel'
    });
  }, true);
  update();
})();
